<template>
  <div class="gr-form">
    <h2>
      Please confirm your email
      <br />
      {{ userDetails.name }}
    </h2>
    <form>
      <div class="alert alert-danger alert-dismissible" role="alert" v-if="showAlertMessage">
        {{apiErrorMessage}}
        <img
          class="close"
          src="assets/images/close.svg"
          data-dismiss="alert"
          aria-label="close"
          @click="showAlertMessage=!showAlertMessage"
        />
        <!-- <button
          type="button"
          class="close"
          data-dismiss="alert"
          aria-label="Close"
          @click="showAlertMessage=!showAlertMessage"
        >
          <span aria-hidden="true">&times;</span>
        </button>-->
      </div>

      <div
        class="alert alert-success alert-dismissible"
        role="alert"
        v-if="showSuccessAlertMessage"
      >
        {{apiSuccessMessage}}
        <img
          class="close"
          src="assets/images/close.svg"
          data-dismiss="alert"
          aria-label="close"
          @click="showSuccessAlertMessage=!showSuccessAlertMessage"
        />
        <!-- <button
          type="button"
          class="close"
          data-dismiss="alert"
          aria-label="Close"
          @click="showSuccessAlertMessage=!showSuccessAlertMessage"
        >
          <span aria-hidden="true">&times;</span>
        </button>-->
      </div>

      <div class="form-group">
        <button
          type="button"
          class="btn btn-primary btn-confirm-email"
          @click="checkEmailConfirmation"
          :disabled="disabled == true"
        >{{ buttonText }}</button>
      </div>
      <div class="form-note text-center">
        <a href="#" @click="resendVerificationEmail">Resend confirmation email</a>
      </div>
      <div class="form-note text-center">
        <a href="#" @click="logout">Logout</a>
      </div>

      <!-- <div class="form-group">
        <button
          type="button"
          class="btn btn-primary"
        >Logout</button>
      </div>-->
    </form>
  </div>
</template>

<script>
import Info from "./Info";
import { mapState } from "vuex";
import {
  CONFIRM_EMAIL,
  LOGIN,
  SET_USER_LOGGED,
  CHANGE_LOGGED_IN_STATUS,
  RESEND_EMAIL,
  REMOVE_USER_DETAILS
} from "../../store/auth/action.type";
export default {
  data() {
    return {
      apiSuccessMessage: "",
      apiErrorMessage: "",
      showSuccessAlertMessage: false,
      showAlertMessage: false,
      disabled: false,
      buttonText: "I have confirmed email"
    };
  },
  components: {
    info: Info
  },
  computed: {
    ...mapState({
      userDetails: state => state.auth.userDetails,
      accessToken: state => state.auth.accessToken,
      refreshToken: state => state.auth.refreshToken
    })
  },
  methods: {
    checkEmailConfirmation(e) {
      e.preventDefault();
      localStorage.setItem(
        "GiftRegistryAccessToken" + process.env.VUE_APP_ACCESS_TOKEN_NAME,
        this.accessToken
      );
      localStorage.setItem(
        "GiftRegistryRefreshToken" + process.env.VUE_APP_ACCESS_TOKEN_NAME,
        this.refreshToken
      );
      this.disabled = true;
      this.buttonText = "Please wait...";
      this.$store
        .dispatch(CONFIRM_EMAIL, this.userDetails._id)
        .then(response => {
          if (response.status != 200) {
            localStorage.removeItem(
              "GiftRegistryAccessToken" + process.env.VUE_APP_ACCESS_TOKEN_NAME
            );
            localStorage.removeItem(
              "GiftRegistryRefreshToken" + process.env.VUE_APP_ACCESS_TOKEN_NAME
            );
            this.showAlertMessage = true;
            this.apiErrorMessage = response.data.message;
          } else {
            this.showSuccessAlertMessage = true;
            this.apiSuccessMessage = response.data.message;
            this.$store.dispatch(SET_USER_LOGGED, true);
            this.$store.dispatch(CHANGE_LOGGED_IN_STATUS, false); //change status of isFirstLogin to false
            this.$router.push({ path: "/dashboard" });
          }
          this.disabled = false;
          this.buttonText = "I have confirmed email";
        })
        .catch(error => {
          this.disabled = false;
          this.buttonText = "I have confirmed email";
          localStorage.removeItem(
            "GiftRegistryAccessToken" + process.env.VUE_APP_ACCESS_TOKEN_NAME
          );
          localStorage.removeItem(
            "GiftRegistryRefreshToken" + process.env.VUE_APP_ACCESS_TOKEN_NAME
          );
          this.showAlertMessage = true;
          this.apiErrorMessage = error.response.data.message;
        });
    },
    resendVerificationEmail(e) {
      e.preventDefault();
      this.$store
        .dispatch(RESEND_EMAIL, this.userDetails.email)
        .then(response => {
          this.apiSuccessMessage = response.data.message;
          this.showSuccessAlertMessage = true;
        })
        .catch(error => {
          this.apiErrorMessage = error.response.data.message;
          this.showAlertMessage = true;
        });
    },
    logout(e) {
      e.preventDefault();
      localStorage.clear();
      this.$store.dispatch(SET_USER_LOGGED, false);
      this.$store.dispatch(REMOVE_USER_DETAILS);
      this.$emit("resetLoginForm");
      this.$router.push({ name: "Login" });
    }
  },
  watch: {
    showAlertMessage(newData) {
      if (newData) {
        var self = this;
        setTimeout(function() {
          self.showAlertMessage = false;
          // self.showSpinner = false;
        }, 2000);
      }
    },
    showSuccessAlertMessage(newData) {
      if (newData) {
        var self = this;
        setTimeout(function() {
          self.showSuccessAlertMessage = false;
          // self.showSpinner = false;
        }, 2000);
      }
    }
  }
};
</script>

<style>
.btn-confirm-email {
  padding: 0px 15px 0px 15px;
  min-width: 12.5rem;
}
.alert {
  text-align: left;
}
</style>